import Image from "./Image";
import Interactive from "./Interactive";
import Video from "./Video";

export default {
  Image,
  Interactive,
  Video
};
